/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type appOnelogin_viewer$ref = any;
export type appOnelogin_QueryVariables = {||};
export type appOnelogin_QueryResponse = {|
  +viewer: ?{|
    +actualPersonId: ?string,
    +component: ?string,
    +$fragmentRefs: appOnelogin_viewer$ref,
  |}
|};
export type appOnelogin_Query = {|
  variables: appOnelogin_QueryVariables,
  response: appOnelogin_QueryResponse,
|};
*/


/*
query appOnelogin_Query {
  viewer {
    actualPersonId
    component(name: "app_onelogin")
    ...appOnelogin_viewer
    id
  }
}

fragment appOnelogin_viewer on Viewer {
  id
  company {
    id
    oneloginEnabled
    oktaEnabled
    AADEnabled
    scimUsernamePassword
    oneloginClientId
    oneloginClientSecret
    oneloginUrl
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "app_onelogin"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"app_onelogin\")"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "appOnelogin_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "appOnelogin_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "appOnelogin_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "oneloginEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "oktaEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "AADEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "scimUsernamePassword",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "oneloginClientId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "oneloginClientSecret",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "oneloginUrl",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "appOnelogin_Query",
    "operationKind": "query",
    "text": "query appOnelogin_Query {\n  viewer {\n    actualPersonId\n    component(name: \"app_onelogin\")\n    ...appOnelogin_viewer\n    id\n  }\n}\n\nfragment appOnelogin_viewer on Viewer {\n  id\n  company {\n    id\n    oneloginEnabled\n    oktaEnabled\n    AADEnabled\n    scimUsernamePassword\n    oneloginClientId\n    oneloginClientSecret\n    oneloginUrl\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '50aa4585446889968b36ee8190af2f03';

module.exports = node;
